import React from 'react';
import { getExceptions } from '../../services/timesheetService';
import PresetReportPage from './components/PresetReportPage';

// AKM POC §5.15 / §7 — Devam Paneli'nden panel süzgeçleriyle açılabilir; ortak süzgeç seti, TA ekip kapsamı ve sunucu
// tarafı Excel / PDF dışa aktarma ortak gövdede (PresetReportPage).
export default function ExceptionsPage() {
  return <PresetReportPage fetchFn={getExceptions} titleKey="pdks.exceptionsTitle" exportUrl="/v1/ta/reports/exceptions/export" />;
}
